<template>
  <v-card class="intern-expansion-panel py-2 px-2" flat tile>
    <DevAddLineInputs
      v-if="showLineInputs"
      :typeLine="lineInputsEdit"
      :objItem="objItem"
      :editableKey="editableKey"
      :headersType="headersType"
      @actionList="actionList"
      @close="closeLine"
    />

    <div class="d-flex justify-end">
      <v-btn @click="addObjArrayDefault()" small color="grey darken-3" class="px-2 white--text">
        Adicionar
        <v-icon class="ml-2" small>add</v-icon>
      </v-btn>
    </div>

    <v-expansion-panels
      v-for="(item, index) in attrListArrayObj"
      :key="index"
      class="mt-2"
      hover
      multiple
      focusable
      tile
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">{{
            setLabel(item.result, index)
          }}</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pt-1">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left px-2" width="45%">Atributo</th>
                  <th class="text-left px-2" width="45%">Valor</th>
                  <th class="text-right px-2" width="10%">
                    <v-card flat tile class="d-flex justify-end mt-1">
                      <v-icon @click="handleShowLineAddAttributes(index)" size="16" color="grey darken-3">add</v-icon>

                      <v-icon @click="handleDeleteParentObj(item, index)" size="16" color="red">delete</v-icon>
                    </v-card>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(itemObj, indexObj) in item.result" :key="indexObj">
                  <template v-if="Object.keys(itemObj)[0] !== schema.paramsVuetify">
                    <td class="px-2">
                      <span class="font-weight-medium grey--text text--darken-3">{{ Object.keys(itemObj)[0] }}</span>
                    </td>

                    <td class="px-2 grey--text text--darken-3" width="45%">{{ Object.values(itemObj)[0] }}</td>

                    <td class="acoes text-right px-3">
                      <v-menu left v-if="hideActions(itemObj)">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-0" size="18">mdi-dots-vertical</v-icon>
                        </template>

                        <v-list class="py-0" dense hover>
                          <v-list-item v-if="actionVerify('edit', itemObj, indexObj)" class="px-0 py-0">
                            <v-list-item-title>
                              <v-btn @click="handleShowLineEditAttributes(itemObj, indexObj, index)" text width="100%">
                                <v-icon color="grey--text text--darken-3" class="mr-2" small>edit</v-icon>Editar
                              </v-btn>
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item v-if="actionVerify('delete', itemObj, indexObj)" class="px-0 py-0">
                            <v-list-item-title>
                              <v-btn @click="deleteObj(itemObj, indexObj)" text width="100%">
                                <v-icon color="red" class="mr-2" small>delete</v-icon>Excluir
                              </v-btn>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </template>

                  <td v-else colspan="3" class="px-0" width="100%">
                    <v-expansion-panels hover focusable>
                      <v-expansion-panel class="v-expansion-panel--expandable-table">
                        <v-expansion-panel-header>
                          <span class="my-0 pl-2 font-weight-medium grey--text text--darken-3">{{
                            Object.keys(itemObj)[0]
                          }}</span>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <DevAttrCrudVuetify
                            :value="Object.values(itemObj)[0]"
                            :btnAdd="false"
                            :listView="attrListArrayObj"
                            :indexListView="indexObj"
                            :valueDad="value"
                            :nameKey="Object.keys(item)[0]"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';
import { randomString } from '@/helpers/dev';

export default {
  props: {
    value: { type: [Object, Array], default: () => ({} || []) },
    model: { type: Object, default: () => ({}) },
    schema: { type: Object, default: () => ({}) },
    orderBy: { type: Boolean, default: () => false },
    headerTypes: { type: Boolean, default: () => false }
  },

  components: {
    DevAddLineInputs: () => import('@/components/dev/dev-add-line-inputs'),
    DevAttrCrudVuetify: () => import('@/components/dev/dev-attr-crud-vuetify')
  },

  data: () => ({
    attrListArrayObj: [],
    showLineInputs: false,
    lineInputsEdit: false,
    objItem: { key: '', value: '' },
    copyModels: {},
    editableKey: true,
    editArray: false,
    headersType: false
  }),

  mounted() {
    this.getValueList(this.value);

    if (Object.keys(this.model)[0] === 'headers') this.headersType = true;
  },

  computed: {
    currentMode() {
      return this.$store.getters['dev/getCurrentMode'];
    }
  },

  methods: {
    getValueList(list) {
      this.attrListArrayObj = [];

      for (let item in list) {
        let listObj = [];

        for (let [key, value] of Object.entries(list[item])) {
          listObj.push({ [key]: value, indexValue: item });
        }

        this.attrListArrayObj.push({ result: listObj });
      }
    },

    setLabel(result, index) {
      for (let itemObj in result) {
        for (let [key, value] of Object.entries(result[itemObj])) {
          if ((key === 'text' || key === 'title') && value !== '') return value;
        }
      }

      return `Objeto - ${index + 1}`;
    },

    hideActions(obj) {
      if (this.schema.hideAttrActions && this.schema.hideAttrActions.indexOf(Object.keys(obj)[0]) >= 0) return false;

      return true;
    },

    actionVerify(type, obj, index) {
      if (type === 'delete' && this.schema.objectRequired) {
        if (typeof obj === 'string') {
          if (this.schema.objectRequired.indexOf(Object.keys(obj)[0]) >= 0) return false;
        }

        if (typeof obj === 'object') {
          if (this.schema.objectRequired[index]) return false;
        }
      }

      return true;
    },

    actionList(result) {
      if (result.type === 'edit') {
        this.editAttrObj(result.key, result.value);

        return;
      }

      this.addObjArray(result.key, result.value);
    },

    closeLine() {
      this.showLineInputs = false;
    },

    handleShowLineAddAttributes(index) {
      this.editableKey = true;
      this.lineInputsEdit = false;
      this.showLineInputs = true;

      this.copyModels.indexValue = index;
    },

    handleShowLineEditAttributes(itemObj, indexAttr, indexLine) {
      let itemKey = Object.keys(itemObj)[0];
      let itemValue = Object.values(itemObj)[0];

      this.editableKey = true;

      // caso o item para editar, contenha no objectRequired, desabilita o campo
      if (this.schema.objectRequired && this.schema.objectRequired.indexOf(Object.keys(itemObj)[0]) >= 0)
        this.editableKey = false;

      this.objItem.key = itemKey;
      this.objItem.value = itemValue;

      this.lineInputsEdit = true;
      this.showLineInputs = true;

      this.copyModels.key = itemKey;
      this.copyModels.value = itemValue;
      this.copyModels.index = indexAttr;
      this.copyModels.indexValue = indexLine;
    },

    addObjArrayDefault() {
      let result = [];
      let objItem = {};

      // caso não tiver atributos padrão, coloca um obj inicial
      if (this.schema.objectRequired.length === 0) {
        result = [
          {
            text: '',
            indexValue: this.attrListArrayObj.length
          }
        ];
      }

      for (let item in this.schema.objectRequired) {
        if (typeof this.schema.objectRequired[item] == 'string') {
          result.push({
            [this.schema.objectRequired[item]]: '',
            indexValue: this.attrListArrayObj.length
          });

          objItem[this.schema.objectRequired[item]] = '';
        } else if (typeof this.schema.objectRequired[item] == 'object') {
          let objKey = Object.keys(this.schema.objectRequired[item])[0];
          let objValue = Object.values(this.schema.objectRequired[item])[0];

          result.push({
            [objKey]: objValue,
            indexValue: this.attrListArrayObj.length
          });

          objItem[objKey] = objValue;
        }
      }

      // --> Adiciona um novo header para Tabs!
      if ('tabHeaders' in this.schema && this.schema.tabHeaders) {
        const currentMode = this.currentMode;
        let value = this.value;
        const nameDinamic = `name-${this.currentMode}-${this.value.length + 1}`;
        let actionDefault = {
          component: 'i4pro-button',
          attributes: {},
          items: [
            {
              id: nameDinamic,
              name: nameDinamic,
              actionName: nameDinamic,
              label: 'Continuar',
              tooltip: 'Continuar para o próximo step',
              tooltipColorClass: 'dark',
              visible: true,
              hiddenByPage: false,
              attributes: {
                color: 'primary',
                class: 'pt-0 pb-0'
              },
              attributesIcon: {
                icon: ''
              },
              params: {
                validate: true
              },
              procedure: {
                name: '[vue].[p_inserir_avaliacao_step_2]'
              },
              after: {
                update: false,
                page: false,
                tab: false,
                step: true,
                parameters: {
                  step: 3
                }
              }
            }
          ]
        };
        let componentStep = false;

        if (this.model.type == 'i4proHorizontalStep' || this.model.type == 'i4proVerticalStep') {
          componentStep = true;
        }

        result.forEach(r => {
          Object.keys(r)[0] === 'id' && (r.id = value.length + 1);
          Object.keys(r)[0] === 'title' && (r.title = `${componentStep ? 'Step ' : 'Tab '} ${value.length + 1}`);
          Object.keys(r)[0] === 'tabName' && (r.tabName = `${currentMode}-${value.length + 1}`);
          Object.keys(r)[0] === 'attributes' &&
            (r.attributes = {
              exact: true,
              ripple: true
            });
        });

        objItem.id = this.value.length + 1;
        objItem.title = `${componentStep ? 'Step ' : 'Tab '} ${this.value.length + 1}`;
        objItem.tabName = `${this.currentMode}-${this.value.length + 1}`;
        objItem.attributes = {
          exact: true,
          ripple: true
        };

        this.model.content[this.value.length + 1] = {
          procedure: { name: 'rur.p_cons_dados_cotacao_f' },
          id: this.value.length + 1,
          disabled: false,
          cardBackgroundColor: '',
          reverseOrder: true,
          fields: [],
          groups: [],
          conditions: [],
          actions: {}
        };

        if (componentStep) {
          actionDefault.step = this.value.length + 1;
          actionDefault.model = randomString();

          this.model.content[this.value.length + 1].actions = actionDefault;

          // resolve bug nos steps, quando add uma nova aba e inclui novos inputs
          let copyContent = Object.assign({}, this.model.content);

          this.model.content = {};
          this.model.content = copyContent;

          objItem.show = true;
          delete objItem.attributes;
        }

        eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV, this.model);
      }

      this.attrListArrayObj.push({ result });

      this.value.push(objItem);
    },

    addObjArray(key, value) {
      this.attrListArrayObj[this.copyModels.indexValue].result.push({
        [key]: value,
        indexValue: this.copyModels.indexValue
      });

      this.value[this.copyModels.indexValue][key] = value;

      this.showLineInputs = false;
    },

    editAttrObj(key, value) {
      this.attrListArrayObj[this.copyModels.indexValue].result[this.copyModels.index] = {
        [key]: value,
        indexValue: this.copyModels.indexValue
      };

      if (key !== this.copyModels.key) {
        delete this.value[this.copyModels.indexValue][this.copyModels.key];
      }

      this.value[this.copyModels.indexValue][key] = value;

      this.showLineInputs = false;

      if (this.copyModels.value !== value && key === 'value' && parseFloat(value) >= 0) {
        this.orderNumber();
      }

      // verifica se todos os itens do objectRequired, estão preenchidos
      // então faz o emit, para recarregar o componente
      if (this.schema.objectRequired.length > 0) {
        let itemsRequired = this.schema.objectRequired.slice();

        this.attrListArrayObj[this.copyModels.indexValue].result.forEach(item => {
          this.schema.objectRequired.forEach(itemRequired => {
            if (item[itemRequired]) {
              let index = itemsRequired.indexOf(itemRequired);
              itemsRequired.splice(index, 1);
            }
          });
        });

        if (itemsRequired.length === 0) eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);

        return;
      }

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    orderNumber() {
      this.attrListArrayObj.sort((a, b) =>
        a.result[1].value < b.result[1].value ? -1 : a.result[1].value > b.result[1].value ? 1 : 0
      );
      this.value.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0));

      let copyItemView = {};
      let copyItemJson = {};

      // quando o value é negativo, retira do array e joga no final do array
      this.attrListArrayObj.forEach((action, index) => {
        if (action.result[1].value === -1) {
          copyItemView = action;
          this.attrListArrayObj.splice(index, 1);
        }
      });

      this.value.forEach((item, index) => {
        if (item.value === -1) {
          copyItemJson = item;
          this.value.splice(index, 1);
        }
      });

      if (Object.keys(copyItemView).length > 0) {
        this.attrListArrayObj.push(copyItemView);
        this.value.push(copyItemJson);

        this.getValueList(this.value);
      }
    },

    handleDeleteParentObj(item, index) {
      this.attrListArrayObj.splice(index, 1);
      this.value.splice(index, 1);

      if ('tabHeaders' in this.schema && this.schema.tabHeaders) {
        const currentMode = this.currentMode;

        delete this.model.content[index + 1];

        this.model.headers.forEach((header, headerIndex) => {
          header.id = headerIndex + 1;
          header.tabName = `${currentMode}-${headerIndex + 1}`;
        });

        let newContent = {};

        Object.entries(this.model.content).forEach((content, contentIndex) => {
          content[1].id = contentIndex + 1;
          newContent[contentIndex + 1] = content[1];
        });

        this.model.content = newContent;
      }
      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV, this.model);
    },

    deleteObj(obj, index) {
      this.attrListArrayObj[obj.indexValue].result.splice(index, 1);

      delete this.value[obj.indexValue][Object.keys(obj)[0]];
    }
  }
};
</script>
